import { createSlice } from "@reduxjs/toolkit";
import { InitialState } from "./models";
import * as Actions from "../actions";

const initialState: InitialState = {
  dataInsumos: {
    tipos: {
      data: [],
    },
    pedidos: {
      data: [],
      requestGetParams: {},
      pagination: {
        page: 1,
        rowsPerPage: 15,
        totalPages: 0,
        totalItems: 0,
      },
    },
    preDetalhes: [],
    detalhes: {
      params: {
        codigoPedido: 0,
        dataInclusao: "",
        codigoPedidoDesmembramento: 0,
        identificadorEntregaFront: 0,
        mensagem: null,
        modalidadeEntrega: "",
        nomeRemetenteNotaFiscal: null,
        numeroContratoCliente: null,
        numeroDigitoVerificadorContratoCliente: null,
        numeroNotaFiscal: 0,
        numeroPedidoOnline: 0,
        sequenciaPedidoOnline: 0,
        serieNotaFiscal: "",
        statusPedido: "",
        tipoDocumento: "",
        tipoDocumentoNumerico: "",
        usuarioInclusao: null,
        valorTotalLiquido: 0,
      },
      cliente: null,
      entrega: null,
      nota: null,
      itensDaNota: null,
    },
  },
  filtersForm: {},
  configTabs: {
    tabInView: 0,
    tabs: [
      {
        title: "Consultar Pedidos",
        index: 0,
        active: true,
        name: "buscaInsumos",
      },
      {
        title: "Detalhes da busca",
        index: 1,
        active: false,
        name: "detalhesBusca",
      },
    ],
  },
};

const buscaInsumosSlice = createSlice({
  name: "buscaInsumosApp/buscaInsumos",
  initialState,
  reducers: {
    changeTab: (state, action) => {
      state.configTabs.tabInView = action.payload;
      state.configTabs.tabs[0].active = action.payload === 0;
      state.configTabs.tabs[1].active = action.payload === 1;
    },
    updateDetalhe: (state, action) => {
      state.dataInsumos.detalhes.params = action.payload;
    },
    updateParamsInsumos: (state, action) => {
      state.dataInsumos.detalhes.params = action.payload;
    },
    setFiltersForm: (state, action) => {
      state.filtersForm = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      Actions.insumosApi.endpoints.getDataPedido.matchFulfilled,
      (state, action) => {
        if (
          action.type ===
          "buscaDeInsumosApp/buscaDeInsumos/insumosApi/executeQuery/fulfilled"
        ) {
          state.dataInsumos.pedidos.data = action.payload;
        }
      }
    );
  },
});

export const { changeTab, updateDetalhe, setFiltersForm, updateParamsInsumos } =
  buscaInsumosSlice.actions;

export default buscaInsumosSlice.reducer;
